/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S4_Li_Uptime_TextInputs */

const tr_servis_s4_li_uptime_text = /** @type {(inputs: Servis_S4_Li_Uptime_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` aylık %99,5 uptime hedefi (planlı bakımlar hariç)`)
};

const en_servis_s4_li_uptime_text = /** @type {(inputs: Servis_S4_Li_Uptime_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` monthly 99.5% uptime target (excluding planned maintenance)`)
};

const de_servis_s4_li_uptime_text = /** @type {(inputs: Servis_S4_Li_Uptime_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Ziel von 99,5 % Uptime pro Monat (ohne geplante Wartungen)`)
};

const ru_servis_s4_li_uptime_text = /** @type {(inputs: Servis_S4_Li_Uptime_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` целевой показатель доступности 99,5 % в месяц (без учета плановых работ)`)
};

/**
* | output |
* | --- |
* | "monthly 99.5% uptime target (excluding planned maintenance)" |
*
* @param {Servis_S4_Li_Uptime_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s4_li_uptime_text = /** @type {((inputs?: Servis_S4_Li_Uptime_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S4_Li_Uptime_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s4_li_uptime_text(inputs)
	if (locale === "de") return de_servis_s4_li_uptime_text(inputs)
	if (locale === "ru") return ru_servis_s4_li_uptime_text(inputs)
	return tr_servis_s4_li_uptime_text(inputs)
});